import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Input, Button, Space, Popconfirm, notification, DatePicker, message, Modal, Tooltip, Upload, Image, Spin } from 'antd';
import {
  SearchOutlined,
  PlusOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  CloseOutlined,
  DownloadOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
import { getCookie } from '../services/cookies';
import config from '../config';
const { RangePicker } = DatePicker;
import { parsePhoneNumberFromString, getExampleNumber } from 'libphonenumber-js';
import examples from 'libphonenumber-js/examples.mobile.json';
export const validatePhoneNumber = phoneCode => (_, value) => {
  if (!value || value.trim() === '') {
    return Promise.reject(new Error('Phone number is required!'));
  }
  const [country, code] = phoneCode.split('-', 2);
  const phoneNumber = parsePhoneNumberFromString(value, country);

  if (!phoneNumber || !phoneNumber.isValid()) {
    const exampleNumber = getExampleNumber(country, examples);
    return Promise.reject(new Error(`Invalid phone number! Required format: ${exampleNumber.formatNational()}`));
  }

  return Promise.resolve();
};

export function filter(dataIndex) {
  return {
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
      const handleReset = () => {
        setSelectedKeys([]);
        clearFilters();
        confirm();
      };
      const selectedValue = selectedKeys?.[0] || ''; // Default to empty string if no value exists
      let transformedValue = dataIndex === 'associated_to' ? selectedValue.toLowerCase() : selectedValue;

      if (dataIndex?.includes('id') || dataIndex === 'value') {
        transformedValue = transformedValue.replace(/\D/g, '');
      }
      return (
        <div
          style={{
            padding: 8,
          }}
        >
          {dataIndex && (dataIndex === 'dod' || dataIndex === 'dob' || dataIndex === 'begin_date' || dataIndex === 'end_date') ? (
            <div
              style={{
                width: '100%',
                marginBottom: 8,
                display: 'block',
              }}
            >
              <RangePicker
                picker="year"
                onChange={e => {
                  setSelectedKeys([e[0].format('YYYY-MM-DD'), e[1].format('YYYY-MM-DD')]);
                }}
              />
            </div>
          ) : (
            <Input
              autoFocus
              placeholder="Type text here"
              value={transformedValue}
              style={{
                marginBottom: 8,
                display: 'block',
              }}
              onChange={e => {
                setSelectedKeys(e?.target?.value ? [e.target.value] : []);
              }}
              onPressEnter={() => {
                confirm();
              }}
              // onBlur={() => {
              //   confirm();
              // }}
            ></Input>
          )}

          <Space>
            <Button
              onClick={() => {
                confirm();
              }}
              type="primary"
              size="small"
              style={{
                width: 120,
              }}
            >
              Search
            </Button>
            <Button
              onClick={handleReset}
              danger
              size="small"
              style={{
                width: 120,
              }}
            >
              Reset
            </Button>
          </Space>
        </div>
      );
    },
    filterIcon: () => {
      return <SearchOutlined />;
    },
  };
}
//Settings button
export function showButton(role, tabs_permissions = null, id = null, permission_array = []) {
  let condition = false;
  if (!!tabs_permissions) {
    condition = !!id ? tabs_permissions.edit : tabs_permissions.create;
  }
  if (permission_array.length > 0 && !!tabs_permissions.edit && !!id) {
    condition = permission_array.includes(id) && true;
  }
  return role == 'admin' || !!condition ? (
    <Button className="save-btn" type="primary" style={{ margin: '0 8px' }} htmlType="submit">
      Save
    </Button>
  ) : (
    ''
  );
}
//Create button
export function createButton(role, tabs_permission, link, text, className = 'align-right') {
  return role == 'admin' || !!tabs_permission.create ? (
    <Link to={link}>
      <Button icon={<PlusOutlined />} className={className} type="primary" size="small">
        {text}
      </Button>
    </Link>
  ) : (
    ''
  );
}
//Table header
export const HeaderCell = props => {
  return (
    <th className="dark-table-header" style={{ backgroundColor: 'rgb(8, 8, 73)', color: 'white' }}>
      {props.children}
    </th>
  );
};
//end antd table

export const getBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
//delete record
export const deleteRecord = (props, id, collection, text, data, dataState, deletePermission = false) => {
  const confirmPopUp = (
    <Popconfirm
      placement="left"
      title={`Are you sure you want to delete this ${text} This action will permanently delete it from the database.`}
      okText="Yes"
      cancelText="No"
      onConfirm={() => deleteConfirm(props, collection, id, data, dataState)}
      overlayStyle={{ width: '500px' }}
    >
      <button className="delete-btn" style={{ cursor: 'pointer' }}>
        <DeleteOutlined style={{ color: 'red' }} />
      </button>
    </Popconfirm>
  );
  if (collection === 'support_table' && (id == process.env.movable_work_id || id == process.env.conceptual_work_id)) {
    return false;
  } else if (props.roleType === 'admin') {
    return confirmPopUp;
  } else if (collection === 'collections' && props.collections_permissions.delete.includes(id)) {
    return confirmPopUp;
  } else if (!!deletePermission && collection !== 'collections') {
    return confirmPopUp;
  }
  return false;
};
let deleteConfirm = async (props, collection, id, data, dataState) => {
  try {
    await props.deleteItem(collection, id);

    dataState(data.filter(item => item.id !== id));
    notification.success({
      message: 'Record deleted successfully!',
      duration: 2,
    });
  } catch ({ errors }) {
    if (errors?.[0]?.message.includes('violates foreign key constraint')) {
      notification.info({
        message: 'You cannot delete this record because it is already associated with another record!',
        duration: 2,
      });
    } else {
      notification.error({
        message: 'An error occurred while deleting the record!',
        duration: 2,
      });
    }
  }
};

//Confirmation modal
export const confirmationModal = async (values = null, title, text, FirstButtonText, SecondButtonText, handleSave, handleOk) => {
  Modal.confirm({
    title: <span>{title}</span>,
    className: 'custom_modal',
    icon: <ExclamationCircleOutlined />,
    content: (
      <div>
        <p>{text}</p>
        <div className="custom_button">
          <Button onClick={() => handleOk(values)}>{FirstButtonText}</Button>
          <Button type="primary" onClick={() => handleSave(values)}>
            {SecondButtonText}
          </Button>
        </div>
      </div>
    ),
    closable: true,
    closeIcon: <Button className="ant-modal-close-x" type="link" icon={<CloseOutlined />} />,
    okButtonProps: { style: { display: 'none' } }, // Hide the OK button
    cancelButtonProps: { style: { display: 'none' } }, //
  });
};

export const intialPaginationState = {
  pageSize: 10,
  current: 1,
  hideOnSinglePage: false,
  showSizeChanger: true,
  showTotal: (total, range) => `Showing ${range[0]}-${range[1]} of ${total} items`,
};
export const showingPageTotalRange = { showTotal: (total, range) => `Showing ${range[0]}-${range[1]} of ${total} items` };
export const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  },
};
export const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 24,
      offset: 0,
    },
  },
};
export const unexpectedError = (errors = null) => {
  console.log(errors);
  const errorsMsg = errors?.errors?.[0]?.['message'] ?? 'Unexpected error occured';
  return notification['error']({
    message: errorsMsg,
    duration: 2,
  });
};
export const handleBackendFormErrors = (formRef, errorResponse) => {
  if (errorResponse.errors !== undefined) {
    for (var i = 0; i < errorResponse.errors.length; i++) {
      var errorObj = errorResponse.errors[i];
      var errorField = errorObj.extensions.field;
      var errorFieldMessage = errorObj.message;
      if (!!errorField) {
        formRef.current.setFields([
          {
            name: errorField,
            errors: [errorFieldMessage],
          },
        ]);
      } else {
        notification['error']({
          message: errorFieldMessage,
          duration: 2,
        });
      }
    }
  } else {
    unexpectedError();
  }
};
export const backButton = (props, url) => {
  setTimeout(() => props.history.push(url, 1500));
};

export const onlyNumbers = eve => {
  if (
    ((eve.which != 46 || eve.target.value.indexOf('.') != -1) && (eve.which < 48 || eve.which > 57)) ||
    (eve.which == 46 && eve.target.value.caret().start === 0)
  ) {
    eve.preventDefault();
  }
};

export const onlyNumber = (_, value) => {
  if (value && isNaN(value)) {
    return Promise.reject(new Error('Enter valid number'));
  }
  return Promise.resolve();
};

// export const beforeUpload = file => {
//   const isLt2M = file.size / 1024 / 1024 <= config.FILE_SIZE_LIMIT;
//   if (!isLt2M) {
//     message.error(`Document must smaller than ${config.FILE_SIZE_LIMIT}MB!`);
//   } else {
//     return false;
//   }
//   return isLt2M || Upload.LIST_IGNORE;
// };

// export const beforeUpload = (file, type = 'image', fileName = null) => {
//   console.log('file :', file);
//   alert('test');
//   let isValidationFailed = false;
//   const isLt2M = file.size / 1024 / 1024 <= config.FILE_SIZE_LIMIT;
//   // Check if it's not an instance of File (e.g., Blob)
//   if (!(file instanceof File)) {
//     notification.error({
//       message: 'Invalid file type. Please upload a valid file.',
//       duration: 2,
//     });
//     isValidationFailed = true;
//     return false;
//   } else {
//     const actualFileName = file.name.toLowerCase();
//     const parts = actualFileName.split('.');
//     const fileExtension = parts.pop();
//     let allowedFormats = config.FileType.imageType;
//     let errorMsg = 'Invalid file format. Please upload a JPEG, JPG, or PNG file.';
//     let allowedExtensions = 'jpeg/jpg/png';
//     if (type === 'docType') {
//       allowedFormats = config.FileType.docType;
//       errorMsg = 'Invalid file format. Please upload a pdf, xls, xlx,or csv file.';
//       allowedExtensions = 'pdf/xls/xlx/csv';
//     }
//     if (type === 'txtType') {
//       allowedFormats = config.FileType.txtType;
//       errorMsg = 'Invalid file format. Please upload a txt file.';
//       allowedExtensions = 'txt';
//     }
//     if (type === 'onlyCSV') {
//       allowedFormats = config.FileType.onlyCSV;
//       errorMsg = 'Invalid file format. Please upload a csv file.';
//       allowedExtensions = 'csv';
//     }
//     if (type === 'onlyXls') {
//       allowedFormats = config.FileType.onlyXls;
//       errorMsg = 'Invalid file format. Please upload a XLS/XLX file.';
//       allowedExtensions = 'xls/xlx';
//     }
//     if (type === 'bookImage') {
//       allowedFormats = config.FileType.bookImage;
//       errorMsg = 'Invalid file format. Please upload a JPEG, JPG, PNG or PDF file.';
//       allowedExtensions = 'jpeg/jpg/png/pdf';
//     }
//     // Check if the file format is allowed
//     if (!allowedFormats.includes(file.type)) {
//       isValidationFailed = true;
//     }
//     if (fileName) {
//       const correctFileName = `${fileName}.${fileExtension}`;
//       if (file.name.toLowerCase() !== correctFileName.toLowerCase()) {
//         errorMsg = `Please upload a file with the name ${fileName}.${allowedExtensions}`;
//         isValidationFailed = true;
//       }
//     }
//     if (!isLt2M) {
//       errorMsg = 'File size must be smaller than 10MB.';
//       isValidationFailed = true;
//     }
//   }
//   // If any validation fails, return Upload.LIST_IGNORE
//   if (isValidationFailed) {
//     notification.error({
//       message: errorMsg,
//       duration: 2,
//     });
//     new Promise((resolve, reject) => {
//       reject(true);
//     });
//     return Upload.LIST_IGNORE;
//   }
//   return false;
// };
/**
 * Per-upload-type rules. Single source of truth shared by `beforeUpload` (validation)
 * and `fileTypeHint` (the hint shown under an upload trigger), so the two cannot drift.
 * `hint` is the short human-readable form of `allowedExtensions`.
 */
export const FILE_TYPE_RULES = {
  image: {
    allowedFormats: config.FileType.imageType,
    errorMsg: 'Invalid image format. Please upload a JPEG, JPG, or PNG file.',
    allowedExtensions: 'jpeg/jpg/png',
    hint: 'JPG or PNG',
  },
  // Alias: several screens pass 'imageType'. Previously this fell through to the
  // default branch, which used these exact image rules — kept explicit here.
  imageType: {
    allowedFormats: config.FileType.imageType,
    errorMsg: 'Invalid image format. Please upload a JPEG, JPG, or PNG file.',
    allowedExtensions: 'jpeg/jpg/png',
    hint: 'JPG or PNG',
  },
  docType: {
    allowedFormats: config.FileType.docType,
    errorMsg: 'Invalid file format. Please upload a PDF, XLS, XLSX, or CSV file.',
    allowedExtensions: 'pdf/xls/xlsx/csv',
    // Kept short so it does not ellipsize in a one-third-width column on tablets.
    // "Excel" covers both XLS and XLSX; the full list stays in errorMsg.
    hint: 'PDF, Excel or CSV',
  },
  txtType: {
    allowedFormats: config.FileType.txtType,
    errorMsg: 'Invalid file format. Please upload a TXT file.',
    allowedExtensions: 'txt',
    hint: 'TXT only',
  },
  onlyCSV: {
    allowedFormats: config.FileType.onlyCSV,
    errorMsg: 'Invalid file format. Please upload a CSV file.',
    allowedExtensions: 'csv',
    hint: 'CSV only',
  },
  onlyXls: {
    allowedFormats: config.FileType.onlyXls,
    errorMsg: 'Invalid file format. Please upload an XLS/XLSX file.',
    allowedExtensions: 'xls/xlsx',
    hint: 'XLS or XLSX',
  },
  bookImage: {
    allowedFormats: config.FileType.bookImage,
    errorMsg: 'Invalid file format. Please upload a JPEG, JPG, PNG, or PDF file.',
    allowedExtensions: 'jpeg/jpg/png/pdf',
    hint: 'JPG, PNG or PDF',
  },
};

/** Hint line for an upload trigger, e.g. "CSV only · up to 10MB". */
export const fileTypeHint = (type = 'image') => {
  const { hint } = FILE_TYPE_RULES[type] || FILE_TYPE_RULES.image;
  return `${hint} · up to ${config.FILE_SIZE_LIMIT}MB`;
};

export const beforeUpload = (file, type = 'image', fileName = null) => {
  // Check if file is an instance of File and validate size
  if (!(file instanceof File) || file.size / 1024 / 1024 > config.FILE_SIZE_LIMIT) {
    notification.error({
      message: 'Invalid file or size exceeds 10MB. Please upload a valid file.',
      duration: 2,
    });
    return Upload.LIST_IGNORE;
  }

  const fileExtension = file.name.split('.').pop().toLowerCase();
  const { allowedFormats, errorMsg, allowedExtensions } = FILE_TYPE_RULES[type] || FILE_TYPE_RULES.image;

  // Validate file type and name (if fileName is provided)
  if (!allowedFormats.includes(file.type) || (fileName && file.name.toLowerCase() !== `${fileName.toLowerCase()}.${fileExtension}`)) {
    notification.error({
      message: fileName ? `Please upload a file with the name ${fileName}.${allowedExtensions}` : errorMsg,
      duration: 2,
    });
    return Upload.LIST_IGNORE;
  }

  return false; // Allow upload if all checks pass
};

export const handleFileChange = ({ fileList: newFileList }, state = null, key = null) => {
  if (state && key) {
    state(prevState => ({
      ...prevState,
      [key]: newFileList,
    }));
  }
};

export const onRemove = file => {
  return new Promise((resolve, reject) => {
    resolve(true);
  });
};
export const components = {
  header: {
    cell: HeaderCell,
  },
};
export const PictureCell = ({ dataIndexValue, getFile, width, isMultiImage = false, style = { marginRight: 8 } }) => {
  if (!!dataIndexValue) {
    const [loadingg, setLoadingg] = useState(true);
    const [imageUrl, setImageUrl] = useState('');

    useEffect(() => {
      const fetchData = async () => {
        try {
          const imageData = await getFile(dataIndexValue);
          setImageUrl(imageData);
        } catch (error) {
          console.error('Error fetching image:', error);
        } finally {
          setLoadingg(false);
        }
      };
      fetchData();
      // Cleanup function to clear the state if the component unmounts
      return () => {
        setImageUrl('');
        setLoadingg(true);
      };
    }, [dataIndexValue]); // Trigger effect when dataIndexValue changes

    // if (loadingg) {
    //   return <span>Loading...</span>;
    // }
    if (loadingg) {
      return (
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Spin size="small" />
        </div>
      );
      // return <Spin size="small" />;
    }
    // return isMultiImage ? (
    //   <Image key={dataIndexValue} width={width} src={imageUrl} style={{ marginRight: 8 }} />
    // ) : (
    //   <Tooltip title={<img style={{ width: 300 }} src={imageUrl} />} placement="left" color={'none'} overlayInnerStyle={{ width: '300px' }}>
    //     <img style={{ width: width }} src={imageUrl} />
    //   </Tooltip>
    // );
    return isMultiImage ? (
      <Image key={dataIndexValue} src={imageUrl} width={width} style={{ marginRight: 8 }} />
    ) : (
      <Tooltip title={<img style={{ width: 300 }} src={imageUrl} />} placement="left" color={'none'} overlayInnerStyle={{ width: '300px' }}>
        <img style={{ width, ...style }} src={imageUrl} />
      </Tooltip>
    );
  }
};
export const dateTime = (date = null) => {
  return date ? moment(date).format('MM/DD/YYYY, h:mm:ss A') : null;
};
export const formatDate = (date = null) => {
  return date ? dayjs.utc(date).local().format() : null;
};
export const parseDate = (date = null) => {
  return date ? dayjs(date) : null;
};
export const onlyYear = (date = null) => {
  return date ? moment(date).format('YYYY') : null;
};
export const onlyYears = (firstDate = null, secondDate = null) => {
  const years = [firstDate, secondDate].map(date => (date ? moment(date).format('YYYY') : null));
  if (years.length === 2 && years[0] === years[1]) {
    return years[0]; // return only one year
  }
  return years.filter(Boolean).join(' - ') || '';
};
// export const heightWidth = (width = null, height = null) => {
//   const data = [width, height].map(item => item ?? null);
//   return data.filter(Boolean).join(' X ') || '';
// };
export const heightWidth = (width = null, height = null) => {
  if (width === null && height === null) {
    return '';
  }
  const formattedWidth = width !== null ? width : 'NA';
  const formattedHeight = height !== null ? height : 'NA';
  return `${formattedWidth} X ${formattedHeight}`;
};

export const stampSize = (nameWidth, cityWidth, height) => {
  const data = [nameWidth, cityWidth, height].map(item => item || 'N/A');
  const allEmpty = data.every(item => item === 'N/A');
  return allEmpty ? '' : `${data.join(' X ')}`;
};

// export const stampSize = (nameWidth = '', cityWidth = '', height = '') => {
//   const data = [nameWidth, cityWidth, height].map(item => item || 'N/A');
//   const allEmpty = data.every(item => item === 'N/A');
//   return allEmpty ? '' : data.join(' X ');
// };

export const showUploadFileList = (file, name) => {
  if (!file) return [];
  return [
    {
      uid: file,
      name: name,
      url: '',
      status: 'done',
    },
  ];
};
export const downloadFile = (file, name) => {
  if (!file || !name) return;
  const accessToken = getCookie('ssfToken');
  // Directus echoes :filename straight back as `Content-Disposition: attachment;
  // filename=...`, so it has to be the real download name — and URL-encoded, since
  // some of them carry spaces.
  const url = `${process.env.apiURL}assets/${file}/${encodeURIComponent(name)}?download=true&access_token=${accessToken}`;
  const link = document.createElement('a');
  link.href = url;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
export const showFilesList = (data, name) => {
  return {
    showDownloadIcon: true,
    // antd hands the list item to `downloadIcon`, which is where the real file lives:
    // showUploadFileList() stores the asset id on `uid` and `filename_download` on
    // `name`. `name` here is only the field's label ("photo", "Provenance Doc"), so
    // downloading by it saved extensionless files that nothing could open.
    downloadIcon: file => (
      <DownloadOutlined onClick={() => downloadFile(file?.uid || data, file?.name || name)} style={{ cursor: 'pointer' }} />
    ),
    showRemoveIcon: data ? false : true,
  };
};
export const getUrl = file => {
  const accessToken = getCookie('ssfToken');
  return `${process.env.apiURL}assets/${file}?access_token=${accessToken}`;
};

export const getFile = fileID => {
  try {
    return fileID ? `${getUrl(fileID)}&width=300&fit=contain&quality=100&cache=${Date.now()}` : null;
  } catch (error) {
    console.log(error, 'errorerrorerrorfetchPossibleValues');
    return null;
  }
};
// export const beforeUploadImage = file => {
//   const isValidImage = config.FileType.imageType.includes(file.type);
//   const isLt2M = file.size / 1024 / 1024 <= config.FILE_SIZE_LIMIT;
//   if (!isLt2M) {
//     notification.error({
//       message: `Document must be smaller than ${config.FILE_SIZE_LIMIT}MB!`,
//       duration: 2,
//     });
//     return true;
//   }
//   if (!isValidImage) {
//     notification.error({
//       message: 'You can only upload JPG or PNG image files!',
//       duration: 2,
//     });
//     return true;
//   }
//   return false;
// };
export const formFieldImgValidation = fileList => {
  // If fileList is empty, pass validation (optional image upload)
  if (!fileList || fileList.length === 0) {
    return Promise.resolve();
  }
  // Validate image type and size
  const file = fileList[0];
  const isAllowedType = config.FileType.imageType.includes(file.type);
  if (!isAllowedType) {
    return Promise.reject('You can only upload JPG, JPEG or PNG');
  }
  return Promise.resolve();
};

export const validatePair =
  (relatedField, message) =>
  ({ getFieldValue, setFields }) => ({
    validator(_, value) {
      const relatedValue = getFieldValue(relatedField);

      // If both fields are empty, remove errors and pass validation
      if (!value && !relatedValue) {
        setFields([
          { name: relatedField, errors: [] },
          { name: _, errors: [] },
        ]);
        return Promise.resolve();
      }

      // If one field is filled but the other is empty, show an error on the empty field
      if (relatedValue && !value) {
        return Promise.reject(new Error(message));
      }

      return Promise.resolve(); // Pass validation if both fields are filled
    },
  });

export const trimmedValues = values => {
  return Object.keys(values).reduce((acc, key) => {
    const value = values[key];
    acc[key] = typeof value === 'string' ? value.trim() : value;
    return acc;
  }, {});
};
